import {
  FormFacilitySelectInput,
  FormRadioButtonGroup,
  FormStaffSelectInput,
} from "apps/portal/src/components/atoms";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";

import {
  AppointableFormValues,
  OtherResourcesRequired,
  ResourceRequired,
} from "../../types";
import {
  OTHER_RESOURCES_REQUIRED_OPTIONS,
  RESOURCE_REQUIRED_OPTIONS,
} from "./constants";

type AppointableWizardResourceFormProps = { disabledEditResource: boolean };

export const AppointableWizardResourceForm = ({
  disabledEditResource,
}: AppointableWizardResourceFormProps) => {
  const { t } = useTranslation();
  const { values } = useFormikContext<AppointableFormValues>();

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-1.5">
          <div className="text-lg font-semibold text-gray-950">
            {t(
              "page.settings.tab.appointments.appointableWizard.appointableWizardResourceForm.availabilityResource",
            )}
          </div>
          <div className="text-sm font-normal text-gray-500">
            {t(
              "page.settings.tab.appointments.appointableWizard.appointableWizardResourceForm.determines",
            )}
          </div>
        </div>
        <FormRadioButtonGroup<AppointableFormValues, ResourceRequired>
          name="resources.resourceRequired"
          options={RESOURCE_REQUIRED_OPTIONS}
          disabled={disabledEditResource}
          disabledTooltip={t(
            "page.settings.tab.appointments.appointableWizard.appointableWizardResourceForm.disabledTooltip",
          )}
        />
      </div>
      <div className="flex flex-col gap-4 lg:flex-row lg:gap-8">
        {values.resources.resourceRequired === "STAFF" ? (
          <FormStaffSelectInput<AppointableFormValues>
            name="resources.appointmentHostsStaff"
            label={t(
              "page.settings.tab.appointments.appointableWizard.appointableWizardResourceForm.appointmentHostsStaff.label",
            )}
            isMulti
            withImageByDefault
            isRequired
            containerClassName="flex-1"
            extraParams={{
              activeUser: true,
            }}
            isClearable
          />
        ) : (
          <FormFacilitySelectInput<AppointableFormValues>
            name="resources.appointmentHostsFacility"
            label={t(
              "page.settings.tab.appointments.appointableWizard.appointableWizardResourceForm.appointmentHostsFacility.label",
            )}
            isMulti
            withImageByDefault
            isRequired
            extraParams={{
              activeUser: true,
            }}
            containerClassName="flex-1"
            isClearable
          />
        )}
        <div className="flex-1" />
      </div>
      <div className="h-px w-full bg-gray-300" />
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-1.5">
          <div className="text-lg font-semibold text-gray-950">
            {t(
              "page.settings.tab.appointments.appointableWizard.appointableWizardResourceForm.otherResourcesRequired",
            )}
          </div>
          <div className="text-sm font-normal text-gray-500">
            {t(
              "page.settings.tab.appointments.appointableWizard.appointableWizardResourceForm.appointmentCan",
            )}
          </div>
        </div>
        <FormRadioButtonGroup<AppointableFormValues, OtherResourcesRequired>
          name="resources.otherResourcesRequired"
          options={OTHER_RESOURCES_REQUIRED_OPTIONS}
          disabled={disabledEditResource}
          disabledTooltip={t(
            "page.settings.tab.appointments.appointableWizard.appointableWizardResourceForm.disabledTooltip",
          )}
        />
        {values.resources.otherResourcesRequired === "YES" && (
          <div className="flex flex-col gap-4 lg:flex-row lg:gap-8">
            {values.resources.resourceRequired === "STAFF" ? (
              <FormFacilitySelectInput<AppointableFormValues>
                name="resources.otherResourcesFacility"
                label={t(
                  "page.settings.tab.appointments.appointableWizard.appointableWizardResourceForm.appointmentHostsFacility.label",
                )}
                isMulti
                withImageByDefault
                isRequired
                extraParams={{
                  activeUser: true,
                }}
                containerClassName="flex-1"
                isClearable
              />
            ) : (
              <FormStaffSelectInput<AppointableFormValues>
                name="resources.otherResourcesStaff"
                label={t(
                  "page.settings.tab.appointments.appointableWizard.appointableWizardResourceForm.appointmentHostsStaff.label",
                )}
                isMulti
                withImageByDefault
                isRequired
                containerClassName="flex-1"
                extraParams={{
                  activeUser: true,
                }}
                isClearable
              />
            )}
            <div className="flex-1" />
          </div>
        )}
      </div>
    </div>
  );
};
